import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import {
  V2ButtonComponent,
  V2DateInputComponent,
  V2DialogModule,
  V2TextInputComponent
} from '@coin/shared/core/ui-storybook';
import { Moment } from 'moment';

@Component({
  selector: 'coin-s-auto-finalize',
  templateUrl: './auto-finalize.component.html',
  styleUrls: ['./auto-finalize.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateModule,
    V2DialogModule,
    V2ButtonComponent,
    V2DateInputComponent,
    FormsModule,
    ReactiveFormsModule,
    V2TextInputComponent
  ]
})
export class AutoFinalizeComponent {
  private readonly dialogRef = inject<MatDialogRef<AutoFinalizeComponent>>(MatDialogRef);

  public message = '';
  private readonly _formBuilder = new FormBuilder().nonNullable;
  public dateFormControl: FormControl<Moment | undefined> = this._formBuilder.control<Moment | undefined>(undefined, Validators.required);

  public get isValidToCreate() {
    return this.dateFormControl.valid;
  }

  public close(): void {
    this.dialogRef.close();
  }

  public create(): void {
    this.dialogRef.close({ message: this.message, date: this.dateFormControl.value?.toISOString() });
  }
}
